import Vue from 'vue';
import VueRouter from 'vue-router';
import {Utils} from '@/utils/Utils';
//main dashboards
// const AdminPanel = () => import('../views/Dashboard/AdminPanel.vue');
const AdminPanel = () => import('../views/Tab/AdminPanel.vue');
const InspectionPanel = () => import('../views/Dashboard/InspectionPanel.vue');
//login components
const Login = () => import('@/views/Dashboard/AdminLogin.vue');

//user components
const CreateUser = () => import('@/views/Admin/User/CreateUser.vue');
const EditUser = () => import('../views/Admin/User/EditUser.vue');
const ChangePassword = () => import('@/views/Admin/User/ChangePassword.vue');

//logo components
const CreateLogo = () => import('@/views/Admin/Profile/Logo/CreateLogo.vue');
const EditLogo = () => import('@/views/Admin/Profile/Logo/EditLogo.vue');

//news components
const CreateNews = () => import('@/views/Admin/Profile/notifications/CreateNews.vue');
const EditNews = () => import('@/views/Admin/Profile/notifications/EditNews.vue');

const InspectionDetailsPDF = () => import('@/components/template/InspectionDetailsHTML.vue');

//bg image components
const UploadBackgroundImage = () => import('@/views/Admin/Profile/BackgroundImage/UploadBackGroundImage.vue');
const UpdateBackGroundImage = () => import('@/views/Admin/Profile/BackgroundImage/UpdateBackgroundImage.vue');

//global setting component
const EditGlobalSetting = () => import('@/views/Admin/Profile/GlobalSetting/EditGlobalSetting.vue');

//email config components
const CreateEmailConfig = () => import('@/views/Admin/Profile/EmailConfigSetting/CreateEmailConfig.vue');
const EditEmailConfig = () => import('@/views/Admin/Profile/EmailConfigSetting/EditEmailConfig.vue');

//roles components
const CreateRole = () => import('@/views/Admin/Roles/RoleList/CreateRole.vue');
const EditRole = () => import('@/views/Admin/Roles/RoleList/EditRole.vue');

//assigned role component
const EditAssignedRole = () => import('@/views/Admin/Roles/AssignedRoleList/EditAssignedRole.vue');

const EditFrame = () => import('@/views/Admin/Ship/EditFrame.vue');
const EditZone = () => import('@/views/Admin/Ship/EditZone.vue');

const CreateCenterPoint = () => import('@/views/Admin/CenterPoints/CreateCenterPoint.vue');
const EditCenterPoint = () => import('@/views/Admin/CenterPoints/EditCenterPoint.vue');

const CreateClass = () => import('@/views/Admin/Class/CreateClass.vue');
const EditClass = () => import('@/views/Admin/Class/EditClass.vue');
const CreateFrame = () => import('@/views/Admin/Ship/CreateFrame.vue');

const CreateZone = () => import('@/views/Admin/Ship/CreateZone.vue');
const ShipInspectionList = () => import('@/views/Inspection/ShipInspectionList.vue');
const InspectionListPage = () => import('@/views/Inspection/InspectionListPage.vue');
const ActionPlanInspectionList = () => import('@/views/Inspection/ActionPlan/ActionPlanList.vue');
const inspectionLocate = () => import('@/views/Inspection/InspectionLocate.vue');
const CreateShip = () => import('@/views/Admin/Ship/CreateShip.vue');
const ShipPanel = () => import('@/views/Tab/ShipPanel.vue');
const EditShip = () => import('@/views/Admin/Ship/EditShip.vue');

const ViewInspection = () => import('@/views/Inspection/ViewInspection.vue');
const EditInspection = () => import('@/views/Inspection/EditInspection.vue');

const ActionPlan = () => import('@/views/Tab/ActionPlanPanel.vue');
const ReInspection = () => import('@/views/Inspection/ReInspection/ReInspectionPanel.vue');
const Test = () => import('@/components/template/HtmlToPdfComponent.vue');
const InspectionHistory = () => import('@/views/Inspection/InspectionHistory.vue');

const InspectionReport = () => import('@/views/Report/InspectionReport.vue');
const Dashboard = () => import('@/views/Dashboard/Dashboard.vue');

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: '/login',
      component: Login,
    },
    {
      path: '/create-logo',
      name: 'create-logo',
      component: CreateLogo,
    },

    {
      path: '/edit-logo/:id',
      name: 'edit-logo',
      component: EditLogo,
    },

    {
      path: '/create-notification',
      name: 'create-news',
      component: CreateNews,
    },

    {
      path: '/edit-notification/:id',
      name: 'edit-news',
      component: EditNews,
    },

    {
      path: '/upload-background-image',
      name: 'upload-background-image',
      component: UploadBackgroundImage,
    },

    {
      path: '/update-background-image/:id',
      name: 'UpdateBackGroundImage',
      component: UpdateBackGroundImage,
    },

    {
      path: '/',
      name: 'home',
      component: Dashboard,
    },
    {
      path: '/create-inspection',
      name: 'create-inspection',
      component: InspectionPanel,
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (Utils.manageRoutePermissions('inspection', 2)) {
          next(); // Take you to /something
        } else {
          // If params.blah is blank or in your case, does not have permission, redirect back to the home page
          next({path: '/'});
        }
      },
    },

    {
      path: '/ship-inspection',
      name: 'ship-inspection',
      component: ShipInspectionList,
    },

    {
      path: '/create-user',
      name: 'create-user',
      component: CreateUser,
    },

    {
      path: '/edit-user/:id',
      name: 'edit-user',
      component: EditUser,
    },
    {
      path: '/change-password/:id',
      name: 'change-password',
      component: ChangePassword,
    },
    {
      path: '/edit-global-setting/',
      name: 'edit-global-setting',
      component: EditGlobalSetting,
    },
    {
      path: '/edit-email-config/:id',
      name: 'edit-email-config',
      component: EditEmailConfig,
    },
    {
      path: '/create-role',
      name: 'create-role',
      component: CreateRole,
    },
    {
      path: '/print',
      name: 'print',
      component: InspectionDetailsPDF,
    },
    {
      path: '/edit-role/:id',
      name: 'edit-role',
      component: EditRole,
    },
    {
      path: '/edit-assigned-role/:id',
      name: 'edit-assigned-role',
      component: EditAssignedRole,
    },

    {
      path: '/edit-frame/:id',
      name: 'edit-frame',
      component: EditFrame,
    },
    {
      path: '/edit-zone/:id',
      name: 'edit-zone',
      component: EditZone,
    },
    {
      path: '/create-center-point',
      name: 'create-center-point',
      component: CreateCenterPoint,
    },
    {
      path: '/edit-center-point/:id',
      name: 'edit-center-point',
      component: EditCenterPoint,
    },

    {
      path: '/create-class',
      name: 'create-class',
      component: CreateClass,
    },
    {
      path: '/create-frame',
      name: 'Create-frame',
      component: CreateFrame,
    },

    {
      path: '/edit-class/:id',
      name: 'edit-class',
      component: EditClass,
    },

    {
      path: '/create-zone',
      name: 'create-zone',
      component: CreateZone,
    },
    {
      path: '/create-ship',
      name: 'create-ship',
      component: CreateShip,
    },
    {
      path: '/ship-list',
      name: 'ship-list',
      component: ShipPanel,
    },
    {
      path: '/edit-ship/:id',
      name: 'edit-ship',
      component: EditShip,
    },
    {
      path: '/locate-inspection/:id',
      name: 'Inspection list location',
      component: inspectionLocate,
    },
    {
      path: '/inspection-list/severity/:id',
      name: 'severity',
      component: InspectionListPage,
    },
    {
      path: '/inspection-list/inspector/:id',
      name: 'inspector',
      component: InspectionListPage,
    },
    {
      path: '/inspection-list/ship/:id',
      name: 'ship',
      component: InspectionListPage,
    },

    {
      path: '/inspection-list/voyage/:id',
      name: 'voyage',
      component: InspectionListPage,
    },

    {
      path: '/inspection-list/findings/:id',
      name: 'findings',
      component: InspectionListPage,
      // props: { inspectionType: true }
      // props: route => ({ query: '' })
    },
    {
      path: '/inspection-list',
      name: 'Inspection list',
      component: InspectionListPage,
    },

    {
      path: '/ship-inspection-list/:shipId?',
      name: 'Ship Inspection list',
      component: ShipInspectionList,
    },

    {
      path: '/inspection/action-plan',
      name: 'Action Plan Inspection list',
      component: ActionPlanInspectionList,
    },

    {
      path: '/view-inspection/:id',
      name: 'View Inspection',
      component: ViewInspection,
      beforeEnter: (to, from, next) => {
        if (Utils.manageRoutePermissions('inspection', 1)) {
          next(); // Take you to /something
        }
      },
    },

    {
      path: '/edit-inspection/:id',
      name: 'Edit Inspection',
      component: EditInspection,
      beforeEnter: (to, from, next) => {
        if (Utils.manageRoutePermissions('inspection', 3)) {
          next(); // Take you to /something
        }
        // else {
        //   // If params.blah is blank or in your case, does not have permission, redirect back to the home page
        //   next({ path: '/' });
        // }
      },
    },
    {
      path: '/action-plan/:id',
      name: 'Action Plan',
      component: ActionPlan,
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (Utils.manageRoutePermissions('action', 2)) {
          next(); // Take you to /something
        }
      },
    },
    {
      path: '/re-inspection/:id',
      name: 'Re inspection',
      component: ReInspection,
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (Utils.manageRoutePermissions('reinspection', 7)) {
          next(); // Take you to /something
        }
      },
    },

    {
      path: '/inspection-history/:id',
      name: 'Inspedtion History',
      component: InspectionHistory,
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (Utils.manageRoutePermissions('inspection', 1)) {
          next(); // Take you to /something
        }
      },
    },

    {
      path: '/report',
      name: 'Inspection Report',
      component: InspectionReport,
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (Utils.manageRoutePermissions('report', 7)) {
          next(); // Take you to /something
        } else {
          // If params.blah is blank or in your case, does not have permission, redirect back to the home page
          next({path: '/'});
        }
      },
    },

    {
      path: '/admin-panel',
      name: 'AdminPanel',
      component: AdminPanel,
      meta: {requiresAuth: true},
      beforeEnter: (to, from, next) => {
        if (Utils.manageRoutePermissions('AdminPanel')) {
          next(); // Take you to /something
        } else {
          // If params.blah is blank or in your case, does not have permission, redirect back to the home page
          next({path: '/'});
        }
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (!Utils.isUserLoggedIn() && to.path !== '/login') {
    next({
      path: '/login',
    });
  } else if (Utils.isUserLoggedIn() && to.path === '/login') {
    next({
      path: '/',
    });
  }
  // else if (Utils.isUserLoggedIn() && to.path === "/admin-panel") {
  //   const user = Vue.prototype.$store.getters.userDetails;
  //

  //   if (to.meta.requiresAuth && user.internal[0].group.groupName === 'ADMIN')
  //   next({
  //     path: '/admin-panel',
  //   });
  //   next({
  //     path: '/',
  //   });
  // }
  else {
    next();
  }
});
export default router;
